import "./App.css";
import Weather from "./Weather";

function App() {
  return <Weather defaultCity="New York" />;
}

export default App;
